
// @ngInject
module.config(function($stateProvider, TagUrl, moment) {

    var currentYear = moment().year();
    var url = new TagUrl()
        .addTagTypes(['participant', 'program', 'location'])
        .setTagDefault('year', currentYear.toString())
        .setTagDefault('affiliation', 'all');

    $stateProvider.state('reports.affnetStandards', {
        url: url.buildUrl('/affnet/summary'),
        params: url.params,
        templateUrl: 'reports/affnet/summary',
        defaultChild: 'reports.affnetStandards.measures',
        data: {tagUrl: url},
        controller: AffnetSummaryController,
        controllerAs: 'ctrl',
        reloadOnSearch: false,
    });

    $stateProvider.state('reports.affnetStandards.measures', {
        url: '',
        reloadOnSearch: false,
        data: {
            showFullAff: true,
            metrics: ['hse', 'litnum', 'placement', 'retention'],
        }
    });

    $stateProvider.state('reports.affnetStandards.benchmarks', {
        url: '/benchmarks',
        reloadOnSearch: false,
        data: {
            showFullAff: false,
            metrics: ['completion', 'attendance', 'recidivism', 'certification', 'vote', 'wage']
        }
    });

});


// @ngInject
function AffnetSummaryController($stateParams, $state, $http, ApiUrl, Debouncer,
                                 permissions) {
    var vm = this;

    this.tags = null;
    this.page = 1
    this.size = 10
    this.sort = "name"
    this.downloadUrl = null;

    this.tagChange = tagChange;
    this.refresh = new Debouncer(refresh).call;
    this.addTagParams = addTagParams;

    this.detailState = detailState;
    this.detailParams = detailParams;

    function tagChange(params) {
        vm.tags = params;
        vm.downloadUrl = buildDownloadURL(params);
        vm.refresh();
    }

    function detailState(report, program) {
        if (program && (report !== 'recidivism' || permissions.viewCriminalJustice)) {
            return 'program.reports.affnet.details';
        } else {
            return 'reports.affnet.index';
        }
    }

    function detailParams(report, program) {
        var params = {};
        params.reportName = report === 'attendance' ? 'completion' : report;
        params.slug = program && program.slug;
        angular.extend(params, vm.tags);
        return params
    }

    function addTagParams(params) {
        params = angular.copy(params);
        angular.extend(params, vm.tags);
        return params;
    }

    function refresh() {
        var params = angular.copy(vm.tags);
        params.sort = vm.sort;
        vm.loading = true;
        $http.get(ApiUrl('report', 'affnet', 'summary'), {params: params})
            .then(function(response) {
                vm.data = response.data.data;
                vm.meta = response.data.meta;
                vm.page = 1;
                vm.pages = Math.ceil(vm.meta.totals.programs / vm.size);
                vm.loading = false;
            });
    }
}


function buildDownloadURL(tags) {
    var slug, i, parts = [];
    for (slug in tags) {
        for (i = 0; i < tags[slug].length; i++) {
            parts.push(slug + '=' + encodeURIComponent(tags[slug][i]));
        }
    }
    return "/api/report/affnet/export.xlsx?" + parts.join('&');
}
